
import axios from '@axios'
import { storePagination } from '@/mixins/store'
import { sorting } from '@/mixins'
import calendarMaintain from './calendar-maintain'

const getInitialState = () => ({
    ...storePagination.state(),
    seasonalCalendars: [],
    calendarTypes: [
        { value: 'NationalHoliday', label: 'Feriado Nacional' },
        { value: 'StateHoliday', label: 'Feriado Estadual' },
        { value: 'MunicipalHoliday', label: 'Feriado Municipal' },
        { value: 'Event', label: 'Evento' },
        { value: 'Other', label: 'Outro' },
    ],
    cities: [],
    filters: {
        name: '',
        eventDate: null,
        type: null,
        province: null,
        city: null,
    },
})

export default {
    namespaced: true,
    state: getInitialState(),

    modules: { calendarMaintain },

    getters: {
        seasonalCalendars: state => state.seasonalCalendars,
        calendarTypes: state => state.calendarTypes,
        cities: state => state.cities,
    },

    mutations: {
        ...storePagination.mutations,
        SET_SEASONAL_CALENDARS(state, items) {
            state.seasonalCalendars = items
        },
        RESET_FILTERS(state) {
            state.filters = {
                name: '',
                eventDate: null,
                type: null,
                province: null,
                city: null,
            }
        },
        REMOVE_CALENDAR(state, id) {
            state.seasonalCalendars = state.seasonalCalendars.filter(c => c.id !== id)
        },
        SET_CITIES(state, { data }) {
            state.cities = data
        },
        CLEAN_STATE(state) {
            const initial = getInitialState()
            Object.keys(initial).forEach(key => {
                state[key] = initial[key]
            })
        },
    },

    actions: {
        ...storePagination.actions,
        async fetchSeasonalCalendars({ commit, state }) {
            const params = {
                ...state.filters,
                pageSize: state.paging.pageSize,
                pageIndex: state.paging.currentPage - 1,
                sortBy: sorting.methods.getSorting(state),
            }
            const { data } = await axios.get('/api/seasonal-calendar', { params })
            commit('SET_SEASONAL_CALENDARS', data.results)
            commit('SET_PAGING', {
                ...state.paging,
                rowCount: data.rowCount || 0,
                rowsInCurrentPage: data.rowsInCurrentPage || 0,
            })
        },

        async setCities({ commit }, cities) {
            if (!Array.isArray(cities)) return
            commit('SET_CITIES', { data: cities })
        },

        async removeCalendar({ commit }, id) {
            await axios.delete(`/api/seasonal-calendar/${id}`)
            commit('REMOVE_CALENDAR', id)
        },

        resetFilters({ commit }) {
            commit('SET_CURRENT_PAGE', 1)
            commit('RESET_FILTERS')
        },
        cleanState({ commit }) {
            commit('CLEAN_STATE')
        },
    },
}
